'use client';

import Box from '@mui/material/Box';

import { BackToTopButton } from 'src/components/animate/back-to-top-button';
import { PageScrollProgress } from 'src/components/animate/scroll-progress/page-scroll-progress';

import { HomeScenes } from './components/home-scenes';
import { HomeStickyCta } from './components/home-sticky-cta';
import { HomeCtaSection } from './components/home-cta-section';
import { HomeHeroSection } from './components/home-hero-section';
import { HomePlansSection } from './components/home-plans-section';
import { HomeChannelsSection } from './components/home-channels-section';
import { HomeLogoStripSection } from './components/home-logo-strip-section';
import { HOME_PAGE_SX, HOME_BACK_TO_TOP_SX } from './constants/home-layout';

// ----------------------------------------------------------------------

/**
 * 서비스 소개(`/intro`). `app/(home)/intro/page.tsx` 가 보는 유일한 것.
 *
 * 조회가 없는 **정적 랜딩**이다 — 이 차례로 세운다:
 * 첫 화면 → 고객사 로고 → 장면 다섯(`HOME_SCENES` — 컨텐츠 허브 · 브랜드 허브 · 크리에이터 허브 · 추적 · 시딩) → 수집 채널 → 요금(`plans`) → 체험(`cta`).
 * 장면은 실제 서비스 부품에 예시 데이터(`home-scene-samples`)를 넣어 그린다. 폰에서는 아래 고정 「무료로 시작하기」가 붙는다.
 * ⚠️ `id` 가 붙은 구역(`plans` · `cta` · `scene-<id>`)은 바깥에서 `#앵커`로 들어올 수 있으니 이름을 바꾸지 않는다.
 * 구역마다 `data-section-id`(hero · logos · scene-<id> · channels · plans · cta)를 단다 — 체류 측정(`page_engaged.deepest_section`)이 읽는 값이라 바꾸면 대시보드가 끊긴다.
 */
export function HomeView() {
  return (
    <>
      <PageScrollProgress />

      <BackToTopButton sx={HOME_BACK_TO_TOP_SX} />

      <Box sx={HOME_PAGE_SX}>
        <HomeHeroSection />
        <HomeLogoStripSection />
        <HomeScenes />
        <HomeChannelsSection />
        <HomePlansSection />
        <HomeCtaSection />
      </Box>

      <HomeStickyCta />
    </>
  );
}
